export default __webpack_public_path__ + "static/media/meli.98d4830e.png";